import type { QueryFilterConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';

export const query: QueryFilterConfig = objFilter => {
    return {
        getFilterByRoleCustomer: {
            id: 'getFilterByRoleCustomer',
            inputType: 'input',
            key: 'taskCheck.ticket.customerId',
            operator: '=',
            value: objFilter.userId,
            includeRoles: [RoleEnum.CUSTOMER],
        },
        getFilterByRoleKTV: {
            id: 'getFilterByRoleKTV',
            inputType: 'input',
            key: 'taskCheck.assigneeId',
            operator: '=',
            value: objFilter.userId,
            includeRoles: [RoleEnum.KTV],
        },
    };
};
